var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "flex justify-around items-center py-20 sm:h-100 max-w-full overflow-x-hidden"
  }, [_c('a', {
    attrs: {
      "href": "https://www.gruenderzentrum-digitalisierung-niederbayern.de/",
      "rel": "noopener",
      "target": "_blank",
      "title": "GZDN"
    }
  }, [_c('cdn-image', {
    attrs: {
      "src": "/logos/sponsors/gzdn.png",
      "size": {
        height: _vm.heightFactor * 48,
        ratio: 3508 / 954
      },
      "max-width": 3508,
      "alt": "GZDN",
      "title": "Unterstützt durch das Gründerzentrum Digitalisierung Niederbayern"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.innkubator.de/",
      "target": "_blank",
      "rel": "noopener",
      "title": "INN.Kubator"
    }
  }, [_c('cdn-image', {
    attrs: {
      "src": "/logos/sponsors/innkubator.png",
      "size": {
        height: _vm.heightFactor * 48,
        ratio: 2722 / 1058
      },
      "max-width": 2722,
      "alt": "INN.Kubator",
      "title": "Unterstützt durch den Inn.Kubator Passau"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.exist.de/DE/Home/inhalt.html",
      "target": "_blank",
      "rel": "noopener",
      "title": "EXIST"
    }
  }, [_c('cdn-image', {
    attrs: {
      "src": "/logos/sponsors/exist.png",
      "size": {
        height: _vm.heightFactor * 56,
        ratio: 1772 / 1181
      },
      "max-width": 1772,
      "alt": "EXIST Logo",
      "title": "Ehemals gefördert durch das EXIST-Gründerstipendium"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://triathlon-niederbayern.de",
      "target": "_blank",
      "rel": "noopener",
      "title": "TRIATHLON NIEDERBAYERN"
    }
  }, [_c('cdn-image', {
    attrs: {
      "src": "/logos/triathlon-niederbayern.png",
      "size": {
        height: _vm.heightFactor * 56,
        ratio: 2822 / 2375
      },
      "max-width": 2822,
      "alt": "TRIATHLON NIEDERBAYERN",
      "title": "Organisator des TRIATHLON NIEDERBAYERN"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }